import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Stack,
  Typography,
  IconButton,
  Button,
  Divider,
} from "@mui/material";
import { Category, Subject, Schedule, Loop, Done } from "@mui/icons-material";

const RightTop = ({ fetchedServiceDetails, refer }) => {
  const navigate = useNavigate();

  const {
    service_refer,
    jcategory,
    jschedule,
    jsubcat,
    price,
    currency,
    title,
    short_key,
  } = fetchedServiceDetails || {};

  const keys = short_key?.split(", ") || [];

  return (
    <Box>
      <Card
        elevation={3}
        sx={{
          borderRadius: 3,
          px: 2,
          py: 1.5,
          border: "1px solid #e0e0e0",
          background: "#f9f9f9",
        }}
      >
        <CardContent>
          <Stack spacing={2}>
            {/* Title and Price */}
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, color: "#333", flex: 1 }}
              >
                {title}
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, color: "#cd4646", whiteSpace: "nowrap" }}
              >
                {currency} {price}
              </Typography>
            </Stack>

            {/* Divider */}
            <Divider />

            {/* Category Info */}
            <Stack spacing={1}>
              {[
                {
                  icon: <Category sx={{ color: "#039faf" }} />,
                  label: "Category",
                  value: jcategory,
                },
                {
                  icon: <Subject sx={{ color: "#039faf" }} />,
                  label: "Sub Category",
                  value: jsubcat,
                },
              ].map((item, i) => (
                <Stack direction="row" spacing={1} alignItems="center" key={i}>
                  {item.icon}
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: "#444", minWidth: 100 }}
                  >
                    {item.label}:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 500, color: "#666" }}
                  >
                    {item.value}
                  </Typography>
                </Stack>
              ))}
            </Stack>

            {/* Schedule & Revision */}
            <Stack direction="row" spacing={3} alignItems="center">
              <Stack direction="row" spacing={1} alignItems="center">
                <Schedule sx={{ color: "#039faf" }} />
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {jschedule}
                </Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <Loop
                  sx={{
                    color: "#039faf",
                    transform: "rotate(-45deg)",
                  }}
                />
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  2 times revision
                </Typography>
              </Stack>
            </Stack>

            {/* Feature List */}
            <Stack spacing={0.5}>
              {keys.length > 1 &&
                keys.map((feature, idx) => (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    key={idx}
                  >
                    <Done sx={{ color: "darkgreen" }} />
                    <Typography
                      variant="body2"
                      sx={{ color: "#555", fontWeight: 500 }}
                    >
                      {feature}
                    </Typography>
                  </Stack>
                ))}
            </Stack>

            {/* Book Button */}
            <Button
              fullWidth
              variant="contained"
              onClick={() => navigate("/book/" + refer)}
              sx={{
                mt: 1,
                textTransform: "capitalize",
                bgcolor: "#14506A",
                fontWeight: 600,
                fontSize: "14px",
                borderRadius: 2,
                "&:hover": {
                  bgcolor: "#0d3b50",
                },
              }}
            >
              Book Now
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default RightTop;
